import CRUDActions from './CRUD';
import {StreamVideo} from '../api/stream/StreamVideo';

export class StreamVideoActions extends CRUDActions {
  prefix = 'stream_video';

  get _model() {
    return StreamVideo;
  }
}

export const streamVideoAction = new StreamVideoActions();



// WEBPACK FOOTER //
// ./src/actions/stream-video.ts